import type { StopStatus } from '@trippath/shared';
import { useTranslation } from 'react-i18next';

/** A stop's status as an icon with its name for screen readers (README §2: icons, not words). */
export function StatusIcon({ status: was }: { status: StopStatus }) {
  const { t } = useTranslation();
  // A dear stop says so by its day's cost and its country's colour, not by a warning.
  const status = was === 'expensive' ? 'estimate' : was;
  const label = t(`stopStatus.${status}`);
  return (
    <span
      className={`status-icon status-icon-${status}`}
      role="img"
      aria-label={label}
      title={label}
    >
      {status === 'booked' && (
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M5 12l5 5 9-10" />
        </svg>
      )}
      {status === 'unresolved' && '?'}
    </span>
  );
}
